var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"fbbcbfa3ec7cc62af6d7294a63b29ff5d65e14ec"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["engine-frontend@apollograph"]={id:"fbbcbfa3ec7cc62af6d7294a63b29ff5d65e14ec"};
      